import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "checkbox", "toggle" ]

  selectAll(event) {
    event.preventDefault();
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = true;
    })
  }

  selectNone(event) {
    event.preventDefault();
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false;
    })

    this.syncToggle()
  }

  toggleAll(event) {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = event.target.checked;
    })
  }

  syncToggle() {
    if (!this.hasToggleTarget) return

    this.toggleTarget.checked = this.checkboxTargets.length > 0 && this.checkboxTargets.every(checkbox => checkbox.checked)
  }
}
